// src/components/common/Panel.jsx
import React from "react";

/**
 * 通用面板容器
 * 接受 children 和自訂 className
 */
export default function ChartPanel({ children, className = "", ...props }) {
  return (
    <div className="relative flex">
      {/* 絕對定位，從父容器 top 撐到 bottom */}
      <div
        className={`
          relative flex items-center justify-center p-4 py-12 w-full h-fit backdrop-blur-[40px]
          bg-[#6D6A6A66] border border-white
          ${className}
        `}
        {...props}
      >
        {children}
      </div>
    </div>
  );
}
